import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React, { Fragment, useContext, useState } from "react";
import AuthContext from "../../services/firebase/auth-context/provider";
import FirebaseHandler from "../../services/firebase";
import styles from "./login.module.css";
import LoadingSpinner from "../common/loading-spinner";
import { createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import MakroAlert, { MakroAlertType } from "../common/alert";
var InputField = function InputField(_ref) {
    var label = _ref.label, type = _ref.type, name = _ref.name, value = _ref.value, onChange = _ref.onChange, _ref$required = _ref.required, required = _ref$required === void 0 ? false : _ref$required;
    var _useState = useState(false), isFocused = _useState[0], setIsFocused = _useState[1];
    var _useState2 = useState(false), isPassVisible = _useState2[0], setIsPassVisible = _useState2[1];
    var getType = function getType() {
        return type === "password" ? isPassVisible ? "text" : "password" : type;
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "inline-block relative max-w-full w-full py-5"
    }, /*#__PURE__*/ React.createElement("label", {
        className: styles.emailLabel + "\n      " + (!isFocused && !value ? styles.largeLabel : styles.smallLabel),
        htmlFor: name
    }, label), /*#__PURE__*/ React.createElement("input", {
        type: getType(),
        name: name,
        required: required,
        className: styles.emailInput,
        value: value,
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        },
        onChange: onChange
    }), type === "password" && /*#__PURE__*/ React.createElement("span", {
        className: styles.showPassIcon + " " + (isPassVisible ? styles.activeIcon : ""),
        onClick: function onClick() {
            return setIsPassVisible(!isPassVisible);
        }
    }));
};
var TermsAndConditions = function TermsAndConditions() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6"
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.termsAndConditions
    }, "Indem Sie fortfahren, stimmen Sie", /*#__PURE__*/ React.createElement("a", {
        href: "/agb/",
        className: styles.link,
        target: "_blank"
    }, " unseren Nutzungsbedingungen"), " und ", /*#__PURE__*/ React.createElement("a", {
        href: "/datenschutz/",
        className: styles.link,
        target: "_blank"
    }, "unserer Datenschutzerkl\xE4rung"), " zu."));
};
var CustomLoadingSpinner = function CustomLoadingSpinner() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center absolute h-8 w-20"
    }, /*#__PURE__*/ React.createElement(LoadingSpinner, {
        color: "makroOrangeLight"
    }));
};
var Login = function Login(_ref2) {
    var _ref2$initialMode = _ref2.initialMode, initialMode = _ref2$initialMode === void 0 ? LoginMode.LOGIN : _ref2$initialMode;
    var _useContext$ = useContext(AuthContext)[0], authenticated = _useContext$.authenticated, user = _useContext$.user;
    var _useState3 = useState("NONE"), state = _useState3[0], setState = _useState3[1];
    var _useState4 = useState(evaluateLoginModeSettings(initialMode)), mode = _useState4[0], setMode = _useState4[1];
    var _useState5 = useState({
        email: "",
        pass: ""
    }), credentials = _useState5[0], setCredentials = _useState5[1];
    var _useState6 = useState(undefined), dedicatedErrorMessage = _useState6[0], setDedicatedErrorMessage = _useState6[1];
    var onSubmit = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(e) {
            var email, pass;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            e.preventDefault();
                            email = credentials.email, pass = credentials.pass;
                            _context.prev = 2;
                            setState("LOADING");
                            if (!(mode.mode === LoginMode.LOGIN)) {
                                _context.next = 9;
                                break;
                            }
                            _context.next = 7;
                            return signInWithEmailAndPassword(FirebaseHandler.auth, email, pass);
                        case 7:
                            _context.next = 17;
                            break;
                        case 9:
                            if (!(mode.mode === LoginMode.REGISTER)) {
                                _context.next = 14;
                                break;
                            }
                            _context.next = 12;
                            return createUserWithEmailAndPassword(FirebaseHandler.auth, email, pass);
                        case 12:
                            _context.next = 17;
                            break;
                        case 14:
                            if (!(mode.mode === LoginMode.FORGOT_PASSWORD)) {
                                _context.next = 17;
                                break;
                            }
                            _context.next = 17;
                            return sendPasswordResetEmail(FirebaseHandler.auth, email);
                        case 17:
                            setState("SUCCESS");
                            _context.next = 24;
                            break;
                        case 20:
                            _context.prev = 20;
                            _context.t0 = _context["catch"](2);
                            setState("ERROR");
                            setDedicatedErrorMessage(determineDedicatedErrorMessage(_context.t0));
                        case 24:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, null, [[2, 20]]);
        }));
        return function onSubmit(_x) {
            return _ref3.apply(this, arguments);
        };
    }();
    var changeMode = function changeMode(mode) {
        setState("NONE");
        setMode(evaluateLoginModeSettings(mode));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "makroLogin"
    }, !authenticated ? /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.mainContainer + " " + styles.shadow
    }, /*#__PURE__*/ React.createElement("form", {
        className: styles.form,
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pt-6 px-6"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: styles.title
    }, mode.title)), state == "ERROR" && /*#__PURE__*/ React.createElement("div", {
        className: "pt-4 px-6"
    }, /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.DANGER,
        title: "Fehler",
        text: dedicatedErrorMessage ? dedicatedErrorMessage : mode.error
    })), state == "SUCCESS" && mode.success && /*#__PURE__*/ React.createElement("div", {
        className: "pt-4 px-6"
    }, /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.SUCCESS,
        text: mode.success
    })), /*#__PURE__*/ React.createElement("div", {
        className: "pt-4 px-6"
    }, /*#__PURE__*/ React.createElement(InputField, {
        label: "E-Mail Adresse",
        type: "email",
        name: "email",
        required: true,
        value: credentials.email,
        onChange: function onChange(e) {
            return setCredentials(Object.assign({}, credentials, {
                email: e.target.value
            }));
        }
    }), mode.mode !== LoginMode.FORGOT_PASSWORD && /*#__PURE__*/ React.createElement(InputField, {
        label: "Passwort",
        type: "password",
        name: "newPassword",
        required: true,
        value: credentials.pass,
        onChange: function onChange(e) {
            return setCredentials(Object.assign({}, credentials, {
                pass: e.target.value
            }));
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.buttonContainer
    }, mode.mode !== LoginMode.LOGIN && /*#__PURE__*/ React.createElement("span", {
        className: styles.link,
        onClick: function onClick() {
            return changeMode(LoginMode.LOGIN);
        }
    }, "Anmelden"), mode.mode !== LoginMode.REGISTER && /*#__PURE__*/ React.createElement("span", {
        className: styles.link,
        onClick: function onClick() {
            return changeMode(LoginMode.REGISTER);
        }
    }, "Registrieren"), mode.mode !== LoginMode.FORGOT_PASSWORD && /*#__PURE__*/ React.createElement("span", {
        className: styles.link,
        onClick: function onClick() {
            return changeMode(LoginMode.FORGOT_PASSWORD);
        }
    }, "Passwort vergessen?"), /*#__PURE__*/ React.createElement("button", {
        disabled: state == "LOADING",
        type: "submit",
        className: styles.button + " " + styles.shadow
    }, state == "LOADING" ? /*#__PURE__*/ React.createElement(CustomLoadingSpinner, null) : mode.submitButtonText))), /*#__PURE__*/ React.createElement(TermsAndConditions, null))) : /*#__PURE__*/ React.createElement(Fragment, null, "Angemeldet als ", /*#__PURE__*/ React.createElement("strong", null, user.email), "."));
};
export default Login;
export var LoginMode;
(function (LoginMode) {
    LoginMode[LoginMode["LOGIN"] = 0] = "LOGIN";
    LoginMode[LoginMode["REGISTER"] = 1] = "REGISTER";
    LoginMode[LoginMode["FORGOT_PASSWORD"] = 2] = "FORGOT_PASSWORD";
})(LoginMode || (LoginMode = {}));
var evaluateLoginModeSettings = function evaluateLoginModeSettings(mode) {
    switch (mode) {
        case LoginMode.REGISTER:
            return {
                mode: LoginMode.REGISTER,
                title: "Erstellen Sie einen Account",
                submitButtonText: "Registrieren",
                success: "Registrierung erfolgreich",
                error: "Bitte versuchen Sie es erneut."
            };
        case LoginMode.FORGOT_PASSWORD:
            return {
                mode: LoginMode.FORGOT_PASSWORD,
                title: "Fordern Sie einen Link zum Zurücksetzen Ihres Passworts an",
                submitButtonText: "Link anfordern",
                success: "Ein Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail Adresse geschickt.",
                error: "Bitte versuchen Sie es erneut."
            };
        case LoginMode.LOGIN:
        default:
            return {
                mode: LoginMode.LOGIN,
                title: "Anmeldung",
                submitButtonText: "Anmelden",
                success: "Anmeldung erfolgreich",
                error: "Die E-Mail Adresse oder das Passwort ist falsch."
            };
    }
};
var determineDedicatedErrorMessage = function determineDedicatedErrorMessage(err) {
    if (err && err.code) {
        if (err.code == "auth/weak-password") {
            return "Das Passwort ist zu schwach. Es muss mindestens 6 Zeichen lang sein.";
        }
        else if (err.code == "auth/invalid-email") {
            return "Ungültige E-Mail Adresse.";
        }
        else if (err.code == "auth/email-already-in-use") {
            return "Für diese E-Mail Adresse gibt es bereits ein Kundenkonto.";
        }
        else if (err.message == "INVALID_PASSWORD") {
            return "Das Passwort ist falsch.";
        }
        else {
            return "Unbekannter Fehler. Bitte versuchen Sie es erneut oder wenden Sie sich an aboservice@makroskop.eu.";
        }
    }
};
